<div class="users-container">
    <app-form-row>
      <app-card-sm-container>
        <div class="user-count-container">
          <div>
                <app-label
                    [text]="'Total Users'">
                </app-label>
          </div>
          <div class="count-container">
            <label>{{userCount}}</label>
          </div>
        </div>
      </app-card-sm-container>
    </app-form-row>

    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Number Of Users'">
        </app-label>
        <app-textbox
            [placeholder]="''"
            [control]="usersControl">
        </app-textbox>
    </app-form-row>

    <app-form-row>
        <app-label
            ngProjectAs="name"
            [text]="'Referal By'">
        </app-label>
        <app-textbox
            [placeholder]="'ObjectID'"
            [maxLength]="30"
            [control]="referalByControl">
        </app-textbox>
    </app-form-row>

    <app-button [button]="createUserButton">
    </app-button>
</div>
